<script>
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import pfMixin from '../../../../mixins/pfMixin'
import stepsMixin from '../../../../mixins/stepsMixin'

export default {
	mixins: [pfMixin, stepsMixin],
	components: {
		McWysiwyg,
	},
	props: ['client', 'analysis', 'name'],
	data() {
		return {
			cliente: null,
			datos: {
				// ValoresGenerales
				analista_local: '',
				modalidad: '',
				analista: '',
				rating_comite: '',
				fecha_rating_comite: '',
				justificacion_rating_comite: '',
				resolucion_comite: '',
				fecha_resolucion_comite: '',
				observaciones_del_comite: '',
				analista_grm_wscr: '',
				analista_gcrc: '',
				banca_segmento: '',
				reestructuracion: '',
				sector: '',
				ambito_de_conformidad: '',
				subsector: '',
				criterio_de_aplicacion: '',
				actividad: '',
				// Caratula
				watch_list: '',
				refinanciado: '',
				calificacion: '',
				provision: '',
				acreditado_propuesto: '',
				areas_de_negocio: [
					{
						id:1,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:2,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:3,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:4,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:5,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:6,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:7,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
					{
						id:8,
						mexico: '',
						banca_empresas: '',
						bbva_bancomer: '',
					},
				],
				moneda_limites: [
					'',
					'',
					'',
					'',
				],
				limite_anterior: ['','','',''],
				limite_actual: ['','','',''],
				limite_nuevo: ['','','',''],
				riesgo_global: {
					area_gcrc: '',
					subarea_gcrc: '',
					area_participante: '',
				},
				// Leveraged Lending
				entidad_excluida_de_analisis_leveraged: '',
				motivo_exclusion_leveraged: '',
				indicador_tipo_analisis: '',
				rating_escala_corta: '',
				rating_ajustado_escala_corta: '',
				indicador_financial_sponsor: '',
				divisa_riesgo: '',
				unidad_divisa_riesgo: '',
				riesgo_total_grupo: '',
				riesgo_potencial: '',
				tipo_cambio: '',
				fecha_tipo_cambio: '',
				filial_leverageds: [
					{
						filial_leveraged: '',
						indicador_subgrupo: '',
						rating_escala_corta: '',
						divisa_riesgo: '',
						unidad_de_riesgo: '',
					},
					{
						filial_leveraged: '',
						indicador_subgrupo: '',
						rating_escala_corta: '',
						divisa_riesgo: '',
						unidad_de_riesgo: '',
					},
					{
						filial_leveraged: '',
						indicador_subgrupo: '',
						rating_escala_corta: '',
						divisa_riesgo: '',
						unidad_de_riesgo: '',
					},
					{
						filial_leveraged: '',
						indicador_subgrupo: '',
						rating_escala_corta: '',
						divisa_riesgo: '',
						unidad_de_riesgo: '',
					},
				]
			},
			config: {
				events: {
					initialized: function () {
						console.log('initialized')
					}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},

	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...this.datos, ...newData.datos})
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		changeTypeAnalysis() {
			console.log('Borrar todo')
		}
	},
}
</script>
<template>
	<div>
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="m-0">Datos Generales</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="save()"> <span class="icon-computer-folder"></span> Guardar</button>
			</div>
		</div>

		<div id="accordion" class="pf-accordion mb-5" data-v-step="pf_dg_0">
			<div class="card">
				<div class="card-header p-1" id="headingOne">
					<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" data-target="#collapse-db1" aria-expanded="true" aria-controls="collapse-db1">
						Valores Generales
					</button>
				</div>

				<div id="collapse-db1" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
					<div class="card-body">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Analista local</span>
									<input class="pf-control__input pf-control--block" v-model="datos.analista_local">
								</label>	
							</div>	
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Modalidad (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.modalidad">
										<option value="">--Seleccione--</option>
										<option value="Operación corto plazo">Operación corto plazo</option>
										<option value="Operación largo plazo">Operación largo plazo</option>
										<option value="Programa financiero">Programa financiero</option>
										<option value="Refinanciación">Refinanciación</option>
										<option value="Restructuración">Restructuración</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Analista</span>
									<input class="pf-control__input pf-control--block" v-model="datos.analista">
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Rating Comité</span>
									<input class="pf-control__input pf-control--block" v-model="datos.rating_comite" placeholder="N/A">
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Fecha Rating Comité</span>
									<input class="pf-control__input pf-control--block" v-model="datos.fecha_rating_comite">
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Justificación Rating Comité</span>
									<input class="pf-control__input pf-control--block" v-model="datos.justificacion_rating_comite">
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Resolución Comité</span>
									<input class="pf-control__input pf-control--block" v-model="datos.resolucion_comite">
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Fecha Resolución Comité</span>
									<input class="pf-control__input pf-control--block" v-model="datos.fecha_resolucion_comite">
								</label>	
							</div>
							<div class="col-12">
								<label class="pf-control">
									<span class="pf-control__label">Observaciones Comité</span>
									<textarea class="pf-control__input pf-control--block" row="5" v-model="datos.observaciones_del_comite"></textarea>
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Analista GRM-WSCR</span>
									<input class="pf-control__input pf-control--block" v-model="datos.analista_grm_wscr">
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Analista GSCRC</span>
									<input class="pf-control__input pf-control--block" v-model="datos.analista_gcrc">
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Banca/Segmento (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.banca_segmento">
										<option value="">--Seleccione--</option>
										<option value="COMERCIAL & INDUSTRIAL (COMPASS)">COMERCIAL & INDUSTRIAL (COMPASS)</option>
										<option value="COMMERCIAL REAL ESTATE (COMPASS)">COMMERCIAL REAL ESTATE (COMPASS)</option>
										<option value="OIL & GAS (COMPRAS)">OIL & GAS (COMPRAS)</option>
										<option value="RESIDENTIAL REAL ESTATE (COMPASS)">RESIDENTIAL REAL ESTATE (COMPASS)</option>
										<option value="WEALTH MANAGEMENT (COMPASS)">WEALTH MANAGEMENT (COMPASS)</option>
										<option value="ASEGURADORAS">ASEGURADORAS</option>
										<option value="BANCA CORPORATIVA">BANCA CORPORATIVA</option>
										<option value="BANCA EMPRESAS">BANCA EMPRESAS</option>
										<option value="BANCA INSTITUCIONAL">BANCA INSTITUCIONAL</option>
										<option value="BANCA INMOBILIARIA">BANCA INMOBILIARIA</option>
										<option value="BANCA MINORISTA">BANCA MINORISTA</option>
										<option value="BANCA PATRIMONIAL">BANCA PATRIMONIAL</option>
										<option value="GLOBAL TRADE FINANCE">GLOBAL TRADE FINANCE</option>
										<option value="RIESGO SOBEARANO">RIESGO SOBEARANO</option>
										<option value="SECTOR FINANCIERO">SECTOR FINANCIERO</option>
										<option value="CORPORATE (GARANTI)">CORPORATE (GARANTI)</option>
										<option value="COMMERCIAL (GARANTI)">COMMERCIAL (GARANTI)</option>
										<option value="SNE (GARANTI)">SNE (GARANTI)</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Reestructuración</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.reestructuracion">
										<option value="">--Seleccione--</option>
										<option value="RESTRUC. NIVEL 1">RESTRUC. NIVEL 1</option>
										<option value="RESTRUC. NIVEL 2">RESTRUC. NIVEL 2</option>
										<option value="RESTRUC. NIVEL 3">RESTRUC. NIVEL 3</option>
										<option value="RESTRUC. NIVEL 4">RESTRUC. NIVEL 4</option>
										<option value="RESTRUC. NIVEL 5">RESTRUC. NIVEL 5</option>
										<option value="RESTRUC. NIVEL 5">RESTRUC. NIVEL 5</option>
										<option value="RESTRUC. LATAM NIVEL 1">RESTRUC. LATAM NIVEL 1</option>
										<option value="RESTRUC. LATAM NIVEL 2">RESTRUC. LATAM NIVEL 2</option>
										<option value="RESTRUC. LATAM NIVEL 3">RESTRUC. LATAM NIVEL 3</option>
										<option value="RESTRUC. LATAM NIVEL 4">RESTRUC. LATAM NIVEL 4</option>
										<option value="RESTRUC. LATAM NIVEL 5">RESTRUC. LATAM NIVEL 5</option>
										<option value="RESTRUC. LATAM NIVEL 5">RESTRUC. LATAM NIVEL 5</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Sector (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.sector">
										<option value="">--Seleccione--</option>
										<option value="Healthcare">Healthcare</option>
										<option value="Financial Institutions">Financial Institutions</option>
										<option value="Utilities">Utilities</option>
										<option value="Transportation">Transportation</option>
										<option value="Telecoms, Technology & Media">Telecoms, Technology & Media</option>
										<option value="Retail">Retail</option>
										<option value="Real Estate">Real Estate</option>
										<option value="Basic Materials">Basic Materials</option>
										<option value="Leisure & Customer Services">Leisure & Customer Services</option>
										<option value="Institutions">Institutions</option>
										<option value="Customer">Customer</option>
										<option value="Financial Services">Financial Services</option>
										<option value="Energy (Oil & Gas)">Energy (Oil & Gas)</option>
										<option value="Construction & Construction Materials">Construction & Construction Materials</option>
										<option value="Capitals goods & Industrial services">Capitals goods & Industrial services</option>
										<option value="Autos, components & Ditable goods">Autos, components & Ditable goods</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Ámbito de conformidad (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.reestructuracion">
										<option value="">--Seleccione--</option>
										<option value="COMISION DE RIESGOS">COMISION DE RIESGOS</option>
										<option value="COMISION DELEGADA PARMANENTE">COMISION DELEGADA PARMANENTE</option>
										<option value="COMITE GWCC">COMITE GWCC</option>
										<option value="GRMC (Global Risk Management Comité)">GRMC (Global Risk Management Comité)</option>
										<option value="CTOG (Comité Téc. de op.globales)">CTOG (Comité Téc. de op.globales)</option>
										<option value="DELEGATION LOCAL">DELEGATION LOCAL</option>
										<option value="RMC LOCAL">RMC LOCAL</option>
										<option value="CTO LOCAL">CTO LOCAL</option>
										<option value="UCRC/GCR LOCAL">UCRC/GCR LOCAL</option>
										<option value="COMITE DIVISIONAL">COMITE DIVISIONAL</option>
										<option value="COMITE TERRITERITORIAL">COMITE TERRITERITORIAL</option>
										<option value="COMITE OFICINA">COMITE OFICINA</option>
										<option value="CCC">CCC</option>
										<option value="OTRO">OTRO</option>
										<option value="DELEGACIÓN">DELEGACIÓN</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Subsector (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.subsector">
										<option value="">--Seleccione--</option>
										<option value="Venta Mayorista Mecancias General">Venta Mayorista Mecancias General</option>
										<option value="Resto de Retailers">Resto de Retailers</option>
										<option value="Venta de productos de primera necesidad">Venta de productos de primera necesidad</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<label class="pf-control">
									<span class="pf-control__label">Criterio de apliación (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.criterio_de_aplicacion">
										<option value="">--Seleccione--</option>
										<option value="CURVA ISORIESGO">CURVA ISORIESGO</option>
										<option value="CONSEJERO">CONSEJERO</option>
										<option value="PARTICIPADA">PARTICIPADA</option>
										<option value="SIN RATING">SIN RATING</option>
										<option value="MEDIO DE COMUNICACION">MEDIO DE COMUNICACION</option>
										<option value="PERSONA DE RELEVANCIA PUBLICA">PERSONA DE RELEVANCIA PUBLICA</option>
										<option value="OTROS">OTROS</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-4 col-lg-4">
								<label class="pf-control">
									<span class="pf-control__label">Actividad (*)</span>
									<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.actividad">
										<option value="">--Seleccione--</option>
										<option value="Ventas por catalogo y por internet">Ventas por catalogo y por internet</option>
										<option value="venta Multinea">venta Multinea</option>
										<option value="venta Especializada">venta Especializada</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-md-6 col-lg-6 mx-auto">
								<p>(*) Campos obligatorios para realizar la propuesta</p>
							</div>
							
						</div>
					</div>
				</div>
			</div>
			<div class="card" data-v-step="pf_dg_2">
				<div class="card-header p-1" id="gdt2" data-v-step="pf_dg_1" @click="goToStep('pfDG', 2)">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#gb2" aria-expanded="true" aria-controls="gb2">
						Carátula
					</button>
				</div>
				<div id="gb2" class="collapse" aria-labelledby="gdt2" data-parent="#accordion">
					<div class="card-body">
						<table class="w-100 mb-3">
							<tbody>
								<tr>
									<td>
										Watch-List
									</td>
									<td>
										Refinanciado
									</td>
									<td>
										Calificación
									</td>
									<td>
										% Provisión
									</td>
								</tr>
								<tr>
									<td class="pr-5">
										<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.watch_list">
											<option value="NO">NO</option>
											<option value="SI">SI</option>
										</select>
									</td>
									<td class="pr-5">
										<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.refinanciado">
											<option value="NO">NO</option>
											<option value="SI">SI</option>
										</select>
									</td>
									<td class="pr-5">
										<input class="pf-control__input pf-control--block" type="text"  v-model="datos.calificacion">

										<!-- <select class="pf-control__input pf-control--block" name="" id="" v-model="datos.calificacion">
											<option value="Normal">Normal</option>
											<option value="Alta">Alta</option>
										</select> -->
									</td>
									<td class="pr-5">
										<input class="pf-control__input pf-control--block" type="text"  v-model="datos.provision">
									</td>
								</tr>
							</tbody>
						</table>
						<div class="col-12 py-3">
							<label class="pf-control">
								<span class="pf-control__label d-inline-block">Acreditado Propuesto</span>
								<input class="pf-control__input " v-model="datos.acreditado_propuesto">
							</label>
						</div>
						<div>
							<table class="w-100 table bg-light table-bordered">
								<tbody>
									<tr>
										<td>ÁREA DE NEGOCIO</td>
										<!-- TODO titulo -->
										<td colspan="3">(*) Campos obligratorios para realizar la propuesta</td>
									</tr>
									<tr v-for="area in datos.areas_de_negocio " :key="`area_negorios_${area.id}`">
										<td class="p-1">
											<button class="btn btn-white p-1 text-primary">
												<span class="icon-trash"></span>
											</button>
											Banco/Área Negocio {{area.id}} <span v-if="area.id === 1">(*)</span>
										</td>
										<!-- TODO lista -->
										<td class="p-1">
											<select class="pf-control__input pf-control--block" type="text" v-model="area.mexico">
												<option value="">--Seleccione--</option>
												<option value="AMERICA DEL SUR">AMERICA DEL SUR</option>
												<option value="MEXICO">MEXICO</option>
												<option value="ESPAÑA Y PORTUGAL">ESPAÑA Y PORTUGAL</option>
												<option value="C&IB">C&IB</option>
												<option value="GARANTI">GARANTI</option>
											</select>
										</td>
										<td class="p-1">
											<select class="pf-control__input pf-control--block" type="text" v-model="area.banca_empresas">
												<option value="">--Seleccione--</option>
												<option value="B. MONORISTA">B. MONORISTA</option>
												<option value="B. CORPORATIVA">B. CORPORATIVA</option>
												<option value="B. INSTITUCIONAL">B. INSTITUCIONAL</option>
												<option value="B. INMBOLIARIA">B. INMBOLIARIA</option>
												<option value="COMMERCIAL AND INDUSTRIAL">COMMERCIAL AND INDUSTRIAL</option>
												<option value="COMMERCIAL REAL ESTATE">COMMERCIAL REAL ESTATE</option>
												<option value="OIL & GAS">OIL & GAS</option>
												<option value="RESIDENTIAL REAL ESTATE">RESIDENTIAL REAL ESTATE</option>
												<option value="WEALTH MANAGEMENT">WEALTH MANAGEMENT</option>
												<option value="B. MONORISTA">B. MONORISTA</option>
												<option value="B. CORPORATIVA">B. CORPORATIVA</option>
												<option value="B. EMPRESAS">B. EMPRESAS</option>
												<option value="B. INSTITUCIONAL">B. INSTITUCIONAL</option>
											</select>
										</td>
										<td class="p-1">
											<select class="pf-control__input pf-control--block" type="text" v-model="area.bbva_bancomer">
												<option value="">--Seleccione--</option>
												<option value="BBVA S.A (ESPAÑA)">BBVA S.A (ESPAÑA)</option>
												<option value="BBVA MEXICO">BBVA MEXICO</option>
												<option value="BBVA PROVINCIAL">BBVA PROVINCIAL</option>
												<option value="BBVA CONTINENTAL">BBVA CONTINENTAL</option>
												<option value="BBVA COLOMBIA">BBVA COLOMBIA</option>
												<option value="BBVA URUGUAY">BBVA URUGUAY</option>
												<option value="BBVA PARAGUAY">BBVA PARAGUAY</option>
												<option value="BBVA CHILE">BBVA CHILE</option>
												<option value="BBVA BANCO FRANCÉS">BBVA BANCO FRANCÉS</option>
												<option value="BBVA IRLANDA">BBVA IRLANDA</option>
												<option value="BBVA SAO PAULO (OFI. REP.)">BBVA SAO PAULO (OFI. REP.)</option>
												<option value="BBVA PORTUGAL">BBVA PORTUGAL</option>
												<option value="BBVA LONDRES (SUC)">BBVA LONDRES (SUC)</option>
											</select>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div>
							
							<table class="w-100 table bg-light table-bordered">
								<tbody>
									<tr>
										<!-- TODO titulo -->
										<td colspan="3" class="text-center">
											ACREDITADO PROPUESTO
										</td>
										<td class="text-center">
											GRUPO
										</td>
										<td class="text-center">
											CE
										</td>
									</tr>
									<tr>
										<td class="small text-center">
											<div class="d-flex">
												<button class="btn btn-white p-1 text-primary">
													<span class="icon-trash"></span>
												</button>
												<p class="mb-0 ml-2">
												
												</p>
											</div>
										</td>
										<td v-for="(item, index) in datos.moneda_limites" :key="`dato_moneda_limites_${index}`" style="vertical-align:middle">
											<select class="pf-control__input pf-control--block" type="text" v-model="datos.moneda_limites[index]">
												<option value="">--Seleccione--</option>
												<option value="EURO">EURO</option>
												<option value="DÓLAR USA">DÓLAR USA</option>
												<option value="YUAN">YUAN</option>
												<option value="PESO MEXICANO">PESO MEXICANO</option>
												<option value="PESO ARGENTINO">PESO ARGENTINO</option>
												<option value="PESO CHILENO">PESO CHILENO</option>
												<option value="NUEVO SOL PERUANO">NUEVO SOL PERUANO</option>
												<option value="PESO COLOMBIANO">PESO COLOMBIANO</option>
												<option value="LIBRA ESTERLINA">LIBRA ESTERLINA</option>
												<option value="LIBRA TURCA">LIBRA TURCA</option>
											</select>
										</td>
									</tr>
									<tr>
										<td class="small text-center">
											<div class="d-flex">
												<button class="btn btn-white p-1 text-primary">
													<span class="icon-trash"></span>
												</button>
												<p class="mb-0 ml-2">
												LÍMITE ANTERIOR
												</p>
											</div>
										</td>
										<td v-for="(item, index) in datos.limite_anterior" :key="`limite_anterior_${index}`" style="vertical-align:middle">
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.limite_anterior[index]">
										</td>
									</tr>
									<tr>
										<td class="small text-center">
											<div class="d-flex">
												<button class="btn btn-white p-1 text-primary">
													<span class="icon-trash"></span>
												</button>
												<p class="mb-0 ml-2">
												LÍMITE ACTUAL
												</p>
											</div>
										</td>
										<td v-for="(item, index) in datos.limite_actual" :key="`dato_limite_actual_${index}`" style="vertical-align:middle">
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.limite_actual[index]">
										</td>
									</tr>
									<tr>
										<td class="small text-center">
											<div class="d-flex">
												<button class="btn btn-white p-1 text-primary">
													<span class="icon-trash"></span>
												</button>
												<p class="mb-0 ml-2">
												LÍMITE NUEVO
												</p>
											</div>
										</td>
										<td v-for="(item, index) in datos.limite_nuevo" :key="`dato_limite_nuevo_${index}`" style="vertical-align:middle">
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.limite_nuevo[index]">
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="mt-4">
							<div class="col-12 col-lg-6 mx-auto">
								<p class="text-center m-0">BANCO BILBAO VIZCAYA ARGENTARIA</p>
								<p class="text-center m-0">GLOBAL RISK MANAGEMENT</p>
								<p class="text-center m-0">GCR - GESTIÓN CORPORATIVA DE RIESGO DE CRÉDITO</p>

								<table class="w-100 table bg-light table-bordered">
									<tbody>
										<tr>
											<td class="text-center small" style="width: 100px">
												ÁREA <br> GCRC
											</td>
											<td>
												<select name="" id="" class="pf-control__input pf-control--block" v-model="datos.riesgo_global.area_gcrc">
													<option value="">--SELECCIONE--</option>
													<option value="GCR UCA-CREP-SECTOR PÚBLICO E&P">GCR UCA-CREP-SECTOR PÚBLICO E&P</option>
													<option value="GCR UCA-CREP-SECTOR PÚBLICO RESTO">GCR UCA-CREP-SECTOR PÚBLICO RESTO</option>
													<option value="GCR UCA-CREP-CONSTRUCCIÓN & INFRAESTRUCTURA">GCR UCA-CREP-CONSTRUCCIÓN & INFRAESTRUCTURA</option>
													<option value="GCR UCA-CREP-REAL ESTATE">GCR UCA-CREP-REAL ESTATE</option>
													<option value="GCR UCA-CONSUM & HC, INS, FIN SERV & OTH">GCR UCA-CONSUM & HC, INS, FIN SERV & OTH</option>
													<option value="GCR UCA-ENER, UTIL, AUTO, TRANS & CAP GO">GCR UCA-ENER, UTIL, AUTO, TRANS & CAP GO</option>
													<option value="GCR UCA-TELECOM, RETAIL, LEISURE & BASIC">GCR UCA-TELECOM, RETAIL, LEISURE & BASIC</option>
												</select>
											</td>
										</tr>
										<tr>
											<td class="text-center small" style="width: 100px">
												SUBÁREA <br> GCRC
											</td>
											<td>
												<select name="" id="" class="pf-control__input pf-control--block" v-model="datos.riesgo_global.subarea_gcrc">
													<option value="">--SELECCIONE--</option>
													<option value="--Defecto--">--Defecto--</option>
													<option value="EMPRESAS AMERICA DEL SUR">EMPRESAS AMERICA DEL SUR</option>
													<option value="CONSUMO Y SERVICIOS ">CONSUMO Y SERVICIOS </option>
													<option value="EMPRESAS ESPAÑA Y PORTUGAL">EMPRESAS ESPAÑA Y PORTUGAL</option>
													<option value="ENERGIA, UTILITIES Y QUIMICO">ENERGIA, UTILITIES Y QUIMICO</option>
													<option value="INDUSTRIA Y BASICO">INDUSTRIA Y BASICO</option>
													<option value="EMPRESAS MEXICO">EMPRESAS MEXICO</option>
													<option value="USA - COMPASS">USA - COMPASS</option>
													<option value="USA - PUERTO RICO">USA - PUERTO RICO</option>
													<option value="CONSTRUCCION E INFRACESTRUCTURAS">CONSTRUCCION E INFRACESTRUCTURAS</option>
													<option value="INMOBILIARIO ">INMOBILIARIO </option>
													<option value="WORK OUT">WORK OUT</option>
													<option value="S. PUBLICO EyP">S. PUBLICO EyP</option>
													<option value="S. PUBLICO RESTO">S. PUBLICO RESTO</option>
													<option value="INSTITUCIONES FINANCIERAS">INSTITUCIONES FINANCIERAS</option>
													<option value="RIESGO EMISOR Y DE CONTRAPARTIDA">RIESGO EMISOR Y DE CONTRAPARTIDA</option>
													<option value="RIESGO PAIS">RIESGO PAIS</option>
													<option value="RIESGO SOBERANO">RIESGO SOBERANO</option>
													<option value="VARIAS AREAS">VARIAS AREAS</option>
													<option value="GCR UCA-CREP-SECTOR PUBLICO (E&P)">GCR UCA-CREP-SECTOR PUBLICO (E&P)</option>
													<option value="GCR UCA-CREP-SECTOR PUBLICO (RESTO)">GCR UCA-CREP-SECTOR PUBLICO (RESTO)</option>
													<option value="GCR UCA-CREP-CONSTRUCCION">GCR UCA-CREP-CONSTRUCCION</option>
													<option value="GCR UCA-CREP-REAL ESTATE">GCR UCA-CREP-REAL ESTATE</option>
													<option value="GCR UCA-CONSUM & HC, INS, FIN SERV & OTH">GCR UCA-CONSUM & HC, INS, FIN SERV & OTH</option>
													<option value="GCR UCA-ENER, UTIL, AUTO, TRANS & CAP GO">GCR UCA-ENER, UTIL, AUTO, TRANS & CAP GO</option>
													<option value="GCR UCA-TELECOM, RETAIL, LEISURE & BASIC">GCR UCA-TELECOM, RETAIL, LEISURE & BASIC</option>
												</select>
											</td>
										</tr>
										<tr>
											<td class="text-center small" style="width: 100px">
												SUBÁREA <br> PARTICIPANTE
											</td>
											<td>
												<select name="" id="" class="pf-control__input pf-control--block" v-model="datos.riesgo_global.area_participante">
													<option value="">--Seleccione--</option>
													<option value="RISH & PORTFOLIO MANAGEMENT">RISH & PORTFOLIO MANAGEMENT</option>
												</select>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card" data-v-step="pf_dg_4">
				<div class="card-header p-1" id="gdt3">
					<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" data-target="#gd3" aria-expanded="true" aria-controls="gd3" data-v-step="pf_dg_3" @click="goToStep('pfDG', 4)">
						Leveraged Lending
					</button>
				</div>
				<div id="gd3" class="collapse" aria-labelledby="gdt3" data-parent="#accordion">
					<div class="card-body">
						<div class="col-12 border px-1 py-3 mb-3">
							<div class="d-flex flex-wrap">
								<div class="col-12 col-md-6">
									<label class="pf-control">
										<span class="pf-control__label">Entidad excluida de Análisis Leveraged(*)(**)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.entidad_excluida_de_analisis_leveraged">
											<option value="">--Seleccione--</option>
										</select>
									</label>	
								</div>	
								<div class="col-12 col-md-6 ">
									<label class="pf-control">
										<span class="pf-control__label">Motivo exlusión leveraged(*)(**)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.motivo_exclusion_leveraged">
											<option value="">--Seleccione--</option>
										</select>
									</label>	
								</div>	
							</div>
						</div>
						<template v-if=" datos.indicador_tipo_analisis == 'Consolidado'">
							<div class="col-12 border px-1 py-3 mb-3">
								<div class="d-flex flex-wrap">
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Tipo Análisis LL.(*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select  @change="changeTypeAnalysis" class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_tipo_analisis">
												<option value="">--Seleccione--</option>
												<option value="Consolidado">Consolidado</option>
												<option value="Individual">Individual</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Rating - Escala Corta</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.rating_escala_corta">
												<option value="">--Seleccione--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Rating Ajustado - Escala Corta (*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.rating_ajustado_escala_corta">
												<option value="">--Seleccione--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Financial Sponsor(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_financial_sponsor">
												<option value="">--Seleccione--</option>
											</select>
										</label>	
									</div>	
								</div>
							</div>
							<div class="col-12 border px-1 py-3 mb-3">
								<div class="d-flex flex-wrap">
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Divisa Riesgo(*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.divisa_riesgo">
												<option value="PESO MEXICANO">PESO MEXICANO</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-6 ">
										<label class="pf-control">
											<span class="pf-control__label">Unidad Divisa Riesgo (*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.unidad_divisa_riesgo">
												<option value="Unidades">Unidades</option>
												<option value="Miles">Miles</option>
												<option value="Millones">Millones</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4 ">
										<label class="pf-control">
											<span class="pf-control__label">Riesgo Total Grupo (*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.riesgo_total_grupo">
										</label>	
									</div>	
									<div class="col-12 col-md-2 ">
										<label class="pf-control">
											<span class="pf-control__label">Mill. €</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.total_mill_e">
										</label>	
									</div>	
									<div class="col-12 col-md-4 ">
										<label class="pf-control">
											<span class="pf-control__label">Riesgo LL. Potencial (*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.riesgo_potencial">
										</label>	
									</div>	
									<div class="col-12 col-md-2 ">
										<label class="pf-control">
											<span class="pf-control__label">Mill. €</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.potencial_mill_e">
										</label>	
									</div>	
									<div class="col-12 col-md-4 ">
										<label class="pf-control">
											<span class="pf-control__label">Tipo cambio(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.tipo_cambio">
										</label>	
									</div>	
									<div class="col-12 col-md-2"></div>
									<div class="col-12 col-md-4 ">
										<label class="pf-control">
											<span class="pf-control__label">Fecha Tipo cambio(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.fecha_tipo_cambio">
										</label>	
									</div>	
									<div class="col-12 col-md-4"></div>

								</div>
							</div>
							<div class="col-12 border px-1 py-3 mb-3">
								<div class="d-flex flex-wrap">
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Divisa EEFF(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.divisa_eeff">
												<option value="">--Seleccione--</option>
												<option value="PESO MEXICANO">PESO MEXICANO</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Unidad divisa EEFF(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.unidad_divisa_eeff">
												<option value="">--Seleccione--</option>
												<option value="Unidades">Unidades</option>
												<option value="Miles">Miles</option>
												<option value="Millones">Millones</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4 ">
										<label class="pf-control">
											<span class="pf-control__label">Tipo cambio a euro EEFF(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.tipo_cambio_a_euro_eeff">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Fecha EEFF Test Leveraged(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.fecha_eeff_test_leveraged">
										</label>	
									</div>	
									<div class="col-12 col-md-4"></div>
									<div class="col-12 col-md-2">
										<label class="pf-control">
											<span class="pf-control__label">Númertr Empleados(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.numero_empleados">
										</label>	
									</div>	
									<div class="col-12 col-md-3">
										<label class="pf-control">
											<span class="pf-control__label">Facturación(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.facturacion">
										</label>	
									</div>	
									<div class="col-12 col-md-2">
										<label class="pf-control">
											<span class="pf-control__label">Mill €</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.facturacion_mill_e">
										</label>	
									</div>	
									<div class="col-12 col-md-3">
										<label class="pf-control">
											<span class="pf-control__label">Total balance(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.total_balance">
										</label>	
									</div>	
									<div class="col-12 col-md-2">
										<label class="pf-control">
											<span class="pf-control__label">Mill €</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.balance_mill_e">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Deuda(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.deudas">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">EBITDA(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.ebitda">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Ratio Deuda/EBITDA(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.ratio_deuda_ebitda">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Deuda Leveraged(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.deuda_leveraged">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Motivo Ajuste Deuda(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.motivo_ajuste_deuda">
												<option value="">--Seleccione--</option>
												<option value="Sin Ajuste">Sin Ajuste</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">NOTAS</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.leveraged_notas">
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Ratio Deuda/Ebitda Leveraged(*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.ratio_deuda_ebitda_leveraged">
										</label>	
									</div>	
								</div>
							</div>
							<div class="col-12 border px-1 py-3 mb-3">
								<div class="d-flex flex-wrap">
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Pyme según BCE(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.pyme_segun_bce">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Tipo Convenants(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.tipo_covenants">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Cumplimiento Convenents(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.cumplimiento_covenants">
												<option value="">N/A</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Comentarios sobre incumplimiento de Covenents</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<input type="text" class="pf-control__input pf-control--block" v-model="datos.comentarios_sobre_incumplimiento_de_covenants">
										</label>	
									</div>	
								</div>
							</div>
							<div class="col-12 border px-1 py-3 mb-3">
								<div class="d-flex flex-wrap">
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Leveraged Sugerido</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_leveraged_sugerido">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-6">
										<label class="pf-control">
											<span class="pf-control__label">Tipo Leveraged Suguerido</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.tipo_leveraged_sugerido">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Leveraged Ajustado(*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_leveraged_ajustado">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Tipo Leveraged Ajustado(*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.tipo_leveraged_ajustado">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Motivo Ajuste Leveraged</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.motivo_ajuste_leveraged">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Leveraged PF Anterior</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_leveraed_pf_anterior">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Tipo Leveraged PF Anterior</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.tipo_leveraged_pf_anterior">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Mot. var. marca LL. (vs. PF Anterior)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.mot_var_marca_ll">
												<option value="">--Selecciona--</option>
											</select>
										</label>	
									</div>	
								</div>
							</div>
						</template>
						<template v-else>
							<div class="col-12 border px-1 py-3 mb-3">
								<div class="d-flex flex-wrap">
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Tipo Análisis LL.(*)(**)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select  @change="changeTypeAnalysis" class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_tipo_analisis">
												<option value="">--Seleccione--</option>
												<option value="Consolidado">Consolidado</option>
												<option value="Individual">Individual</option>
											</select>
										</label>	
									</div>	
							
									<div class="col-12 col-md-4">
										<label class="pf-control">
											<span class="pf-control__label">Indicador Financial Sponsor(*)</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<select class="pf-control__input pf-control--block" name="" id="" v-model="datos.indicador_financial_sponsor">
												<option value="">--Seleccione--</option>
												<option value="SI">SI</option>
												<option value="NO">NO</option>
											</select>
										</label>	
									</div>	

									<div class="col-12 col-md-4">
										<label class="pf-control text-center">
											<span class="pf-control__label">Actualizar Tipo de cambio</span>
											<!-- TODO listas desde caratula de los cobos select -->
											<button class="btn btn-light btn-sm rounded-0 font-weight-bold"> <span class="icon-refresh"></span> Actualizar</button>
										</label>	
									</div>
								</div>
							</div>
						</template>

						<div class="col-12 border px-1 py-3 mb-3">
							<table class="table pf-table-odd  table-bordered">
								<tr>
									<th></th>
									<th>FILIAL LEVERAGED</th>
									<th>INDICADOR SUBGRUPO</th>
									<th>RATING - ESCALA CORTA</th>
									<th>DIVISA RIESGO (*)(**)</th>
									<th>UNIDAD DE REIGOS(*)(**)</th>
								</tr>
								<tr v-for="(n, index) in datos.filial_leverageds" :key="`fl_${index}`">
									<td class="p-1">
										<button class="btn btn-light p-1 text-primary">
											<span class="icon-trash"></span>
										</button>
									</td>
									<td class="p-1">
										<input v-model="n.filial_leveraged" class="pf-control__input w-100"  type="text">
									</td>	
									<td class="p-1">
										<select class="pf-control__input w-100"  name="" id=""  v-model="n.indicador_subgrupo">
											<option value="">N/A</option>
										</select>
									</td>	
									<td class="p-1">
										<select class="pf-control__input w-100"  name="" id="" v-model="n.rating_escala_corta">
											<option value="">BB</option>
										</select>
									</td>	
									<td class="p-1">
										<select class="pf-control__input w-100"  name="" id="" v-model="n.divisa_riesgo">
											<option value="">PESOS MEXICANOS</option>
										</select>
									</td>	
									<td class="p-1">
										<select class="pf-control__input w-100"  name="" id="" v-model="n.unidad_de_riesgo">
											<option value="">Unidades</option>
										</select>
									</td>	
								</tr>
							</table>
							<p>TEST</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pf-controls-flow">
			<div class="container">
				<div class="d-flex">
					<div class="ml-auto pf-controls-flow__button">
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold"  @click="save()" @click.prevent="goToStep('pfDG',6)" data-v-step="pf_dg_5"> <span class="icon-computer-folder"></span> Guardar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>